/** Traduit les refus fréquents de la connexion e-mail. (Google : `web-commun/connexion-google`, via `./google`.) */
export function traduireErreurConnexion(message: string): string {
  const m = message.toLowerCase()
  if (m.includes('invalid login credentials')) return 'E-mail ou mot de passe incorrect.'
  if (m.includes('email not confirmed')) return "Cette adresse e-mail n'est pas encore confirmée."
  if (m.includes('failed to fetch') || m.includes('load failed') || m.includes('networkerror')) {
    return 'Connexion impossible : vérifiez votre réseau.'
  }
  return message
}
